import { isBelowIE11 } from 'constants/browser';
import { detect } from 'detect-browser';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'utils/i18n';

interface Props {
  className?: string;
  message?: string;
}

const OutdatedBrowserWarning: FC<Props> = ({
  className = 'outdated-browser-warning',
  message,
}) => {
  const { t } = useTranslation('common');
  const [browser, setBrowser] = useState<ReturnType<typeof detect> | undefined>(
    undefined
  );
  const defaultMessage = message || t('outdated_browser_warning.message');

  useEffect(() => {
    setBrowser(detect());
  }, []);

  if (browser && isBelowIE11(browser)) {
    return <div className={className}>{defaultMessage}</div>;
  }
  return null;
};

export default OutdatedBrowserWarning;
